import React, { useState, useEffect } from 'react'
import Container from '../common/application_container'
import { getUser } from '../../actions/session';
import Axios from 'axios';
import { Notifications } from '../common/notification';
import { CALL_RESTRICTION_DELETE, CALL_RESTRICTION_LISTING, LOGIN_URL } from '../../config/rest_endpoints';
import CustomLoader from '../common/loader';
import { RC_LOAD_LOGIN } from '../routers/RouteConstants';
import { withRouter } from 'react-router';
import CustomModal from '../common/modal';
import AddRestriction from './addRestriction';
import Pagination from "react-js-pagination"
import Select from 'react-select';



const CallRestriction = (props) => {
    const [table, setTable] = useState([])
    const [User] = useState(getUser())
    const [isGetting, setIsGetting] = useState(false)
    const [isModal, setIsModal] = useState(false)
    const [isModalDelete, setIsModalDelete] = useState(false)
    const [activePages, setActivePages] = useState(1)
    const [itemCounts, setItemCounts] = useState({ label: '10', value: 10 })
    const [totalCount, setTotalCount] = useState(null)
    const [deleteData, setDeleteData] = useState({})
    const [listingOption] = useState([
        {label:'All' , value:'All'},
        {label:'Others' , value:'Others'},
    ])
    const [SelectOption, setSelectOption] = useState( {label:'All' , value:'All'})
    const [isLoad, setIsLoad] = useState(false)
    const [countList] = useState([
        { label: '10', value: 10 },
        { label: '15', value: 15 },
        { label: '25', value: 25 },
        { label: '50', value: 50 },
        { label: 'All', value: 400 },
    ])

    useEffect(() => {
        getRestrictionList()
    }, [activePages])

    useEffect(() => {
        getRestrictionList()
    }, [SelectOption])

    useEffect(() => {
        getRestrictionList()
    }, [itemCounts])

    const modalOpen = () => {
        setIsModal(true)
    }

    const modalOpenDelete = (data) => {
        setIsModalDelete(true)
        setDeleteData(data)
    }

    const modalClose = () => {
        setIsModal(false)
        setIsModalDelete(false)
    }


    const handleSelectPagination = (itemCounts) => {
        setItemCounts(itemCounts)
    }

    const handleSelect = (SelectOption) => {
        console.log(`pageNumber`, SelectOption)
        setSelectOption(SelectOption)
    }

    const handlePageNumber = (pageNumber) => {
        console.log(`pageNumber`, pageNumber)
        setActivePages(pageNumber)
    }

    const getRestrictionList = () => {
        setIsGetting(true)
        var headers = { "Authorization": "Bearer " + User.token };
        Axios.get(`${CALL_RESTRICTION_LISTING}?page=${activePages}&search=&limit=${itemCounts.value}&type=${SelectOption.value}`, { headers }).then(res => {
            if (res) {
                const resp = res.data.data
                setTable(resp)
                setIsGetting(false)
                setTotalCount(res.data.pageinfo.totalCount)

            }
        }).catch(err => {
            const alert = err.response
            setIsGetting(false)
            console.log(`alert.data.message`, alert.data.message)
            if (alert.data.message === 'invalid or expired jwt') {
                localStorage.removeItem('user');
                props.history.push(RC_LOAD_LOGIN)
                Notifications.notify(alert.data.message, "Token Expire", "error")
            }
            Notifications.notify(alert.data.message, "Failed", "error")
        })
    }

    const deleteCallListing = () => {
        setIsLoad(true)
        var headers = { "Authorization": "Bearer " + User.token };
        Axios.delete(`${CALL_RESTRICTION_DELETE}/${deleteData['id']}/delete`, { headers }).then(res => {
            if (res) {
                console.log(`res`, res)
                Notifications.notify('Successfuly deleted', "Deleted", "success")
                getRestrictionList()
                setIsLoad(false)
                modalClose()
            }
        }).catch(err => {
            const alert = err.response
            console.log(`alert.data.message`, alert.data.message)
            if (alert.data.message === 'invalid or expired jwt') {
                localStorage.removeItem('user');
                props.history.push(RC_LOAD_LOGIN)
                setIsLoad(false)
                Notifications.notify(alert.data.message, "Token Expire", "error")
            }
            Notifications.notify(alert.data.message, "Failed", "error")
        })
    }

    const renderReportTable = () => {
        if (table.length === 0 || table === null) {
            return (
                <div className="ml-4 mt-2">
                    <div className="dataTables_info" id="DataTables_Table_0_info" role="status" aria-live="polite">Showing 0 of 0 entries</div>
                    <div className="dataTables_paginate paging_simple_numbers" id="DataTables_Table_0_paginate"></div>
                </div>
            )
        }
        else {
            return table.map((row, idx) => {
                return (
                    <tr key={idx} className="right_align">
                        <td>{row.account}</td>
                        <td>{row.carrier}</td>
                        <td>{row.prefix}</td>
                        <td>{row.note}</td>
                        <td>{row.createDate}</td>
                        <td><i className="fa fa-trash fs-20" aria-hidden="true" onClick={modalOpenDelete.bind(this,row)}></i></td>
                    </tr>
                )
            })
        }

    }

    const createModal = {
        details: {
            info: "Create Restriction",
            msg: <AddRestriction close={modalClose} refreshList={getRestrictionList} />
        },
        confirmBtn: { label: "Update", action: '' },
        crossBtn: { action: modalClose },
        cancelBtn: { label: "Cancel", action: modalClose }
    }

    const deleteModal = {
        details: {
            info: `Delete`,
            msg: (
                <div>
                    <div class="modal-body">
                        <h4>Are you sure want to delete {deleteData['prefix']} ? </h4>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-light" onClick={modalClose} data-dismiss="modal">Close</button>
                        <button type="button" class="btn btn-danger" onClick={deleteCallListing}> Confirm <i class={isLoad ? "icon-spinner4 spinner ml-1 " : 'fa fa-trash ml-1 '}></i></button>
                    </div>
                </div>
            )
        },
        confirmBtn: { label: "Update", action: '' },
        crossBtn: { action: modalClose },
        cancelBtn: { label: "Cancel", action: modalClose }
    }

    return (
        <Container title="Carrier Restriction" title1="Section" icon="fas fa-phone-slash">
            <CustomModal
                visibility={isModal}
                customBodyCSS={"h20"}
                modalType={""}
                modalHeader={""}
                modalSize={"large"}
                details={createModal.details}
                showBtns={false}
                cancelBtn={createModal.cancelBtn}
                crossBtn={createModal.crossBtn}
            />
            <CustomModal
                visibility={isModalDelete}
                customBodyCSS={"h20"}
                modalType={""}
                modalHeader={""}
                modalSize={"large"}
                details={deleteModal.details}
                showBtns={false}
                cancelBtn={deleteModal.cancelBtn}
                crossBtn={deleteModal.crossBtn}
            />
            <div style={{border:'none',borderRadius:'5px',boxShadow:'0 0 20px rgba(0,0,0,.08)'}} className="card card-body">
                    <div className="card-header header-elements-inline p-0 py-1 mb-1">
                        <h5 style={{fontWeight:'700',fontSize:'24px'}} className="card-title"></h5>
                        <div className="header-elements">
                        <button type="submit" className="btn btn-success btn-sm main-button ml-3 float-right" onClick={modalOpen}>Create Restriction  <i class="fas fa-plus ml-2"></i></button>
                        </div>
                    </div>
                    <div className='d-flex justify-content-start flex-wrap bg-light rounded border p-0 mb-1'>
                        <div className='py-2'>
                            <div id="DataTables_Table_0_filter" className="dataTables_filter p-0 mt-3">
                                <div class="input-group">
                                    <input type="text" class="form-control border-right-0" placeholder="Filter Restriction" />
                                    <span class="input-group-append">
                                        <button class="btn search-button" type="button"><i class="fa fa-search"></i></button>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className="py-2 px-3 mt-3">
                            <Select
                                value={SelectOption}
                                onChange={handleSelect}
                                options={listingOption}
                                placeholder="Select Account Type"
                                className="w-10em"
                            />
                        </div>
                        
                    </div>
                    {/* row 1 */}
                    <div className="card-header header-elements-inline p-0 py-1 mb-2">
                        <h5 style={{fontWeight:'700',fontSize:'24px'}} className="card-title"></h5>
                        <div className="header-elements">
                        <div className="py-2 mb-0 ml-auto" style={{ width: '9em' }}>
                                    <Select
                                        value={itemCounts}
                                        onChange={handleSelectPagination}
                                        options={countList}
                                        placeholder="Select item count"
                                        className="w-7em"
                                    />
                        </div>
                        </div>
                    </div>
                    <div id="DataTables_Table_0_wrapper" className="dataTables_wrapper no-footer ">
                   
                               
                    <div className="datatable-scroll " style={{ overflowX: 'auto' }}>
                       
                        <table className="table-style table table-striped table-bordered border dataTable no-footer" id="DataTables_Table_0" role="grid" aria-describedby="DataTables_Table_0_info">
                            <thead>
                                <tr className="stickeyHeader table-heading-style">
                                    <th>Account</th>
                                    <th>Carrier</th>
                                    <th>Prefix</th>
                                    <th>Note</th>
                                    <th>Created Date</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {isGetting ? <CustomLoader /> : renderReportTable()}
                            </tbody>
                        </table>
                    </div>
                    <div className="datatable-footer mt-1">
                        <div className="dataTables_paginate paging_simple_numbers" id="DataTables_Table_0_paginate"></div>
                        <div className="mt-3 text-center">
                            <Pagination
                                activePage={activePages}
                                itemsCountPerPage={itemCounts}
                                totalItemsCount={totalCount}
                                pageRangeDisplayed={5}
                                onChange={handlePageNumber}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </Container>
    )
}

export default withRouter(CallRestriction)